import { useFeatureFlags } from 'ha/modules/FeatureFlags';

export const usePageRedesign = () => {
  const { marketplaceLDPDesignUpdate } = useFeatureFlags();

  return marketplaceLDPDesignUpdate === 'on';
};
